import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import AddrSearch from 'components/common/AddrSearch/AddrSearch';
import { notification, Table, Modal, Tooltip, Button, Input } from 'antd';

@inject(({ orderStore }) => ({ 
  lastOrder: orderStore.lastOrder,
  disLastOrder: orderStore.disLastOrder,

  addOrderList: orderStore.addOrderList,
}))
@observer
class OrderModal extends Component {
  state = {
    modalOpenAddr: false,

    orAddr: '',
    orAddrDetail: '',
    orZipCd: '',
    mgrUserId: '',
    mgrHp: '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen) {
      if (nextProps.modalOpen === true) {
        this.props.disLastOrder();
      }
    }

    if (nextProps.lastOrder !== this.props.lastOrder) {
      if (nextProps.modalOpen === true) {
        this.setState({
          orAddr: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orAddr !== undefined && nextProps.lastOrder.orAddr !== null) ? nextProps.lastOrder.orAddr : '',
          orAddrDetail: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orAddrDetail !== undefined && nextProps.lastOrder.orAddrDetail !== null) ? nextProps.lastOrder.orAddrDetail : '',
          orZipCd: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orZipCd !== undefined && nextProps.lastOrder.orZipCd !== null) ? nextProps.lastOrder.orZipCd : '',
          mgrUserId: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.mgrUserId !== undefined && nextProps.lastOrder.mgrUserId !== null) ? nextProps.lastOrder.mgrUserId : '',
          mgrHp: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.mgrHp !== undefined && nextProps.lastOrder.mgrHp !== null) ? nextProps.lastOrder.mgrHp : '',
        });
      }
    }
  }

  render() {
    const { modalOpenAddr, orZipCd, orAddr, orAddrDetail, mgrUserId, mgrHp} = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '사번', dataIndex: 'caUserId', width: 120, align: 'center' },
      { title: '사원명', dataIndex: 'userNm', width: 150, align: 'center' },
      { title: '직무', dataIndex: 'userJobNm', width: 150, align: 'center' },
      { title: '성별', dataIndex: 'userSex', key: 'userSex', width: 80, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
            {item === "A" && <Fragment>공용</Fragment>}
          </Fragment>
        )}
      },
      { title: '상품명', dataIndex: 'gdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'caGdSize', width: 150, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.caEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'caCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'gdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.caCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      // { title: '신청사유', dataIndex: 'reqReason', width: 130, align: 'center',
      //   render: (item, record, index) => { 
      //     return (
      //       item !== undefined && item !== null && item !== "" &&
      //       <Tooltip placement="topLeft" title={record.reqReason}>
      //         <span style={{color: 'blue'}}>신청사유</span>
      //       </Tooltip>
      //     )
      //   },
      // },
    ];

    const totalMoney = () => {
      let total = 0;
      this.props.cartList.map(item=>{return(
        total = total + parseInt(item.gdPrice)*parseInt(item.caCnt)
      )});
      return (
        <Fragment>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Fragment>
      );
    };
    return (
      <Modal
        width={1300}
        title="주문하기"
        cancelText={"취소"}
        okText={"주문하기"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onOk={()=>{
          if (orAddr === '' || orAddrDetail === '' || orZipCd === '') {
            notification.warning({placement: 'bottomLeft', message: `배송지를 확인해주세요.`, duration: 2});
            return false;
          }
          if (mgrUserId === '' || mgrHp === '') {
            notification.warning({placement: 'bottomLeft', message: `인수자 정보를 확인해주세요.`, duration: 2});
            return false;
          }
          // console.log("this.props.ceType", this.props.ceType);
          if (window.confirm(`주문하기 이후에 주문내역은 수정이 불가합니다 주문 하시겠습니까? `)) {
            this.props.addOrderList(
              orAddr,
              orAddrDetail, 
              orZipCd, 
              mgrUserId, 
              mgrHp,
              '',
              '',
              (this.props.ceType === process.env.REACT_APP_TYPE_CENTER || this.props.ceType === process.env.REACT_APP_TYPE_YUJIN) 
                ? "1" : "2"
              );
          }
        }}
      >
        <div className="order_modal_p">
          <table className="table_st_wrap">
            <tbody>
              <tr>
                <th rowSpan="2">배송지</th>
                <td>
                  <Button 
                    type="primary"
                    onClick={()=>this.setState({modalOpenAddr: true})}
                  >우편번호 검색</Button>
                  <p>
                    <b>우편번호</b>
                    <span className="prog_input" style={{ width: '100px' }}>{orZipCd}</span>
                    <b>주소</b>
                    <span className="prog_input">{orAddr}</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><b>상세주소</b></p>
                  <Input
                    style={{ width: '50%' }}
                    value={orAddrDetail}
                    onChange={(e)=>this.setState({orAddrDetail: e.target.value })}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table className="table_st_wrap">
            <tbody>
              <tr>
                <th>인수자</th>
                <td>
                  <Input
                    style={{ width: '50%' }}
                    value={mgrUserId}
                    onChange={(e)=>this.setState({mgrUserId: e.target.value })}
                  />
                </td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>
                  <Input
                    style={{ width: '50%' }}
                    value={mgrHp}
                    onChange={(e)=>this.setState({mgrHp: e.target.value })}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="order_p_total">
          <div>총 <span className="num"> {this.props.cartList.length}</span>건 </div>
          <div>총 주문액 <span className="num">{totalMoney()}</span>원</div>
        </div>

        <Table 
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={this.props.cartList}
          pagination={false}
          scroll={{ x: 1200, y: 300 }}
        />
        <div className="last_chk_text02">
          <b>주문 하시겠습니까?</b>
          <br />
          (단, 주문 이후에 주문내역은 수정이 불가합니다.)<br/>
          {/* ※ 주문수량이 10벌 이하이면 배송비 3,600원이 포함됩니다. */}
        </div>

        <AddrSearch
          modalOpen={modalOpenAddr}
          modalClose={()=>this.setState({modalOpenAddr: false})}
          setAddrInfo={(data)=>{
            this.setState({ orAddr: data.addr, orZipCd: data.orZipCd });
          }}
        />
      </Modal>

      
    );
  }
}

export default withRouter(OrderModal);
